/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_Clipboard_LabelInputs */

const es_chat_share_modal_clipboard_label = /** @type {(inputs: Chat_Share_Modal_Clipboard_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace copiado al portapapeles`)
};

const en_chat_share_modal_clipboard_label = /** @type {(inputs: Chat_Share_Modal_Clipboard_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Link copied to clipboard" |
*
* @param {Chat_Share_Modal_Clipboard_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_clipboard_label = /** @type {((inputs?: Chat_Share_Modal_Clipboard_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_Clipboard_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_clipboard_label(inputs)
	return en_chat_share_modal_clipboard_label(inputs)
});
export { chat_share_modal_clipboard_label as "chat.share_modal.clipboard_label" }